/**
 * Склоняет слово в зависимости от числа
 * @param number - число для склонения
 * @param forms - массив из 3 форм: [1, 2-4, 5-20]
 * @returns склонённое слово
 */

export const declension = (number: number, forms: [string, string, string]): string => {
  const n = Math.abs(number) % 100
  const n1 = n % 10

  // Числа от 11 до 19 всегда используют форму множественного числа
  if (n > 10 && n < 20) {
    return forms[2]
  }

  // Остальные случаи по последней цифре
  if (n1 > 1 && n1 < 5) {
    return forms[1]
  }

  if (n1 === 1) {
    return forms[0]
  }

  return forms[2]
}
